<template>
<v-container
  pt-4
  mt-5
  pl-1
  pr-1>
  <v-layout>
    <v-flex xs12>
      <panel title="User Info">
        <v-text-field
          :rules="[required]"
          v-model="user.name"
          label="Name"
          required
        />
        <v-text-field
          :rules="[required]"
          v-model="user.email"
          label="Email"
          required
        />
     <div
        v-if="error"
        class="danger-alert"
      >
        {{ error }}
      </div>
      <v-btn
        v-if="$store.state.isUserLoggedIn && $store.state.user.role === 'Admin'"
        :color="strongColor"
        dark
        @click="create"
        >
        Create Master Account
      </v-btn>
     </panel>
    </v-flex>
    </v-layout>
    <v-layout>
    <v-flex 
    my-2
    xs12>
     <!-- <panel
        title="IDS Numbers"
        class="ml-2"
      /> -->
      
    </v-flex>
    </v-layout> 
    </v-container>

</template>

<script>
import UsersService from '@/services/UsersService'
import { STRONG_COLOR } from "@/components/globals/consts";

export default {
	data () {
		return {
			user: {
				name: null,
        email: null //,
        //password: null
      },
      strongColor: STRONG_COLOR,
			error: null,
			required: (value) => !!value || 'Required.'
		}
	},
	methods: {
		async create () {
			this.error = null
			const areAllFieldsFilledIn = Object
				.keys(this.user)
				.every(key => !!this.user[key])
			if (!areAllFieldsFilledIn) {
				this.error = 'Please fill in all the required fields.'
				return
			}
    var results = null
			try {
        this.user.password = this.user.email
        results = await UsersService.post(this.user)
				this.$router.push({
					name: 'users'
				})
			} catch (error) {
        //console.log(results)
        console.log(error)
        this.error = error.response.data.error

				//console.log(err)
			}
		}
	}
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/CreateUser.vue